"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1566],{

/***/ 91566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProjectHero_ProjectHero; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./components/TinaResponsiveAsset/index.ts + 3 modules
var TinaResponsiveAsset = __webpack_require__(77284);
// EXTERNAL MODULE: ./components/StyledRichText/index.tsx + 3 modules
var StyledRichText = __webpack_require__(31585);
// EXTERNAL MODULE: ./theme/mixins/padding.ts
var padding = __webpack_require__(54986);
// EXTERNAL MODULE: ./components/FormattedText/index.tsx
var FormattedText = __webpack_require__(89867);
;// CONCATENATED MODULE: ./blocks/ProjectHero/ProjectHero.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        ";\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  padding-top: 1.4375rem;\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    max-height: ",
        ";\n\n    margin: 0;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  width: 100%;\n  margin: 3px;\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n  line-height: 2.8125rem;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 70%;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  color: ",
        ";\n  line-height: 2.8125rem;\n  ",
        "\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  p {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 2fr;\n  "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: 1fr 2fr 0.5fr;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 3rem;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}
function _templateObject17() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject17 = function() {
        return data;
    };
    return data;
}







const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-0"
})(_templateObject1(), (0,padding/* blockPadV */.zr)({
    pt: "no",
    pb: "no"
}), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject(), (0,padding/* blockPadH */.XA)());
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.bg;
});
const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-1"
})(_templateObject2(), (0,padding/* blockW */.g5)());
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-2"
})(_templateObject4(), ()=>(0,padding/* blockPadH */.XA)(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject3());
});
const StyledAsset = (0,styled_components_browser_esm/* default */.ZP)(TinaResponsiveAsset/* default */.Z).withConfig({
    componentId: "sc-8ef270b9-3"
})(_templateObject7(), (param)=>{
    let { theme: { mq , gfx  } , fullImageHeight  } = param;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), fullImageHeight ? "auto" : "70vh", mq.md(_templateObject5(), gfx.mixins.mv(5, {
        md: 3
    }), fullImageHeight ? "auto" : "665px"));
});
const ProjectName = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8ef270b9-4"
})(_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.themeColorOpacities.fg50;
}, (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(0);
});
const ProjectLead = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-8ef270b9-5"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(6, {
        md: 5
    });
}, (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
}, (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject9());
});
const ProjectDetailItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-6"
})(_templateObject11());
const TopGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-7"
})(_templateObject14(), (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject12());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.lg(_templateObject13());
}, (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(6, {
        lg: 0
    });
});
const ProjectDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ef270b9-8"
})(_templateObject15());
const DetailLabel = (0,styled_components_browser_esm/* default */.ZP)(FormattedText/* default */.Z).withConfig({
    componentId: "sc-8ef270b9-9"
})(_templateObject16(), (param)=>{
    let { theme  } = param;
    return theme.themeColorOpacities.fg50;
}, (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(4, {
        md: 2
    });
});
const DetailParagraph = (0,styled_components_browser_esm/* default */.ZP)(FormattedText/* default */.Z).withConfig({
    componentId: "sc-8ef270b9-10"
})(_templateObject17(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
}, (param)=>{
    let { theme  } = param;
    return theme.gfx.mixins.mb(0);
});
const ProjectHero = (param)=>{
    let { respImage , projectName , projectLead , projectScopeItems , projectAbout , projectAboutRichText , fullImageHeight  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                respImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAsset, {
                    asset: respImage,
                    fullImageHeight: fullImageHeight
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        projectName && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectName, {
                            children: projectName
                        }),
                        projectLead && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectLead, {
                            children: projectLead
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectDetailItems, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopGroup, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailLabel, {
                                                pFormat: "monoRegular16",
                                                children: "Scope"
                                            }),
                                            (projectScopeItems === null || projectScopeItems === void 0 ? void 0 : projectScopeItems.body) && (projectScopeItems === null || projectScopeItems === void 0 ? void 0 : projectScopeItems.pFormat) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichText/* default */.Z, {
                                                pFormat: projectScopeItems.pFormat,
                                                content: projectScopeItems.body
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProjectDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailLabel, {
                                                pFormat: "monoRegular16",
                                                children: "About"
                                            }),
                                            projectAbout && /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailParagraph, {
                                                pFormat: "sansRegular24",
                                                children: projectAbout
                                            }),
                                            projectAboutRichText && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRichText/* default */.Z, {
                                                pFormat: projectAboutRichText.pFormat,
                                                content: projectAboutRichText.body
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProjectHero_ProjectHero = (ProjectHero);

;// CONCATENATED MODULE: ./blocks/ProjectHero/index.ts



/***/ }),

/***/ 3185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GfxImage_GfxImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/GfxImage/GfxImage.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const GfxImage = (param)=>{
    let { layout , quality , src , width =0 , height =0 , objectFit , blurDataURL , placeholder ="empty" , alt , ...rest } = param;
    if (!src) {
        return null;
    }
    const isLayoutFill = layout === "fill";
    const isSvg = src.includes(".svg");
    const imageProps = {
        layout,
        ...rest,
        ...isSvg && {
            unoptimized: true
        },
        ...placeholder === "blur" && {
            blurDataURL: blurDataURL
        },
        ...objectFit !== "none" && {
            style: {
                objectFit
            }
        },
        ...!isLayoutFill && {
            width: width,
            height: height
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: src,
        placeholder: placeholder,
        alt: alt,
        quality: quality,
        ...imageProps
    });
};
/* harmony default export */ var GfxImage_GfxImage = ((0,styled_components_browser_esm/* default */.ZP)(GfxImage).withConfig({
    componentId: "sc-2250b3a7-0"
})(_templateObject()));

;// CONCATENATED MODULE: ./components/GfxImage/index.ts



/***/ }),

/***/ 31585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ StyledRichText_StyledRichText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tinacms/dist/rich-text/index.es.js
var index_es = __webpack_require__(48766);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./components/TinaRichText/TinaRichText.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  li {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}




const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d745d383-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.themeColors.fg;
});
const TinaRichText = (param)=>{
    let { components , content  } = param;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: "rich-text",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* TinaMarkdown */.t, {
            content: content,
            components: components
        })
    });
};
/* harmony default export */ var TinaRichText_TinaRichText = (TinaRichText);

;// CONCATENATED MODULE: ./components/TinaRichText/index.ts


// EXTERNAL MODULE: ./components/FormattedText/index.tsx
var FormattedText = __webpack_require__(89867);
;// CONCATENATED MODULE: ./components/StyledRichText/StyledRichText.tsx




const components = (pFormat)=>{
    return {
        p: (props)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                pFormat: pFormat,
                ...props,
                children: props.children
            });
        },
        a: (props)=>{
            var ref;
            const hostname =  true ? window.location.hostname : 0;
            if ((props === null || props === void 0 ? void 0 : props.url) && (props === null || props === void 0 ? void 0 : (ref = props.url) === null || ref === void 0 ? void 0 : ref.indexOf(hostname)) >= 0) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    ...props,
                    children: props.children
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: props === null || props === void 0 ? void 0 : props.url,
                    target: "_blank",
                    rel: "noreferrer",
                    ...props,
                    children: props.children
                });
            }
        }
    };
};
const StyledRichText = (param)=>{
    let { pFormat ="default" , content  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TinaRichText_TinaRichText, {
        components: components(pFormat),
        content: content
    });
};
/* harmony default export */ var StyledRichText_StyledRichText = (StyledRichText);

;// CONCATENATED MODULE: ./components/StyledRichText/index.tsx



/***/ }),

/***/ 54995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var components_GfxImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3185);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-height: 100vh;\n    flex: 0; \n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border-radius: ",
        "px;\n      "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  padding: ",
        ";\n  ",
        "\n  ",
        "\n  /* desktop only need >= 0, cause if not we would simply take the border radius from mobile.\nMobile doesn't need it, since if you set mobile to 0, it reads as false and doesnt add border-radius */\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}




const Image = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(components_GfxImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-da1c7ae5-0"
})(_templateObject4(), (param)=>{
    let { $horizontalPaddingMobile  } = param;
    return $horizontalPaddingMobile && "0 1.5rem";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { theme  } = param;
    return theme.mq.md(_templateObject1());
}, (param)=>{
    let { theme: { mq  } , mobileborderradius , desktopborderradius  } = param;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject3(), "border-radius: ".concat(mobileborderradius ? mobileborderradius : 16, "px;"), mq.md(_templateObject2(), desktopborderradius ? desktopborderradius : 24));
});
const TinaAsset = (param)=>{
    let { asset , className , ...props } = param;
    // do not render anything if no URL is provided
    if (!asset || !(asset === null || asset === void 0 ? void 0 : asset.src)) {
        return null;
    }
    // We don't want to apply either attribute if both conditions are not met
    const imageBlur = (asset === null || asset === void 0 ? void 0 : asset.placeholder) === "blur" && (asset === null || asset === void 0 ? void 0 : asset.blurDataURL) && {
        placeholder: asset === null || asset === void 0 ? void 0 : asset.placeholder,
        blurDataURL: asset === null || asset === void 0 ? void 0 : asset.blurDataURL
    };
    const imageProps = {
        ...props,
        ...imageBlur
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Image, {
        ...imageProps,
        alt: (asset === null || asset === void 0 ? void 0 : asset.alt) || "image description",
        src: (asset === null || asset === void 0 ? void 0 : asset.src) || "",
        priority: Boolean(asset === null || asset === void 0 ? void 0 : asset.priority),
        quality: (asset === null || asset === void 0 ? void 0 : asset.quality) || 75,
        objectFit: (asset === null || asset === void 0 ? void 0 : asset.objectFit) || "none",
        className: className,
        $horizontalPaddingMobile: (asset === null || asset === void 0 ? void 0 : asset.horizontalPadding) ? true : undefined,
        $maxHeightMobile: (asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile) ? asset === null || asset === void 0 ? void 0 : asset.maxHeightMobile : undefined,
        width: (asset === null || asset === void 0 ? void 0 : asset.width) || 0,
        height: (asset === null || asset === void 0 ? void 0 : asset.height) || 0
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(TinaAsset).withConfig({
    componentId: "sc-da1c7ae5-1"
})(_templateObject5()));


/***/ }),

/***/ 48642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TinaAsset__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TinaAsset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54995);



/***/ }),

/***/ 77284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TinaResponsiveAsset_TinaResponsiveAsset; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/lodash/first.js
var first = __webpack_require__(8804);
var first_default = /*#__PURE__*/__webpack_require__.n(first);
// EXTERNAL MODULE: ./node_modules/lodash/takeRightWhile.js
var takeRightWhile = __webpack_require__(43464);
var takeRightWhile_default = /*#__PURE__*/__webpack_require__.n(takeRightWhile);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(39693);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./components/TinaAsset/index.ts
var TinaAsset = __webpack_require__(48642);
// EXTERNAL MODULE: ./node_modules/lodash/set.js
var lodash_set = __webpack_require__(36968);
;// CONCATENATED MODULE: ./lib/tina/responsiveAssetConfig.ts

const responsiveAssetConfig_responsiveAssetConfig = (param)=>{
    let { label , name  } = param;
    return {
        label,
        name,
        description: "Image URL and metadata",
        type: "object",
        fields: [
            {
                type: "image",
                label: "Image Src",
                name: "src",
                ui: {
                    validate: (value, allValues, meta, field)=>{
                        if (value) {
                            const i = new Image();
                            const fieldRoot = field.name.replace(/\.src$/, "");
                            i.onload = ()=>{
                                set(allValues, "".concat(fieldRoot, ".width"), i.naturalWidth);
                                set(allValues, "".concat(fieldRoot, ".height"), i.naturalHeight);
                            };
                            i.src = value;
                        }
                    }
                }
            },
            {
                name: "width",
                label: "Width",
                type: "number",
                default: 0,
                ui: {
                    component: ()=>null
                }
            },
            {
                name: "height",
                label: "Height",
                type: "number",
                default: 0,
                ui: {
                    component: ()=>null
                }
            },
            {
                type: "boolean",
                label: "Priority",
                name: "priority"
            },
            {
                type: "string",
                label: "Alt Text",
                name: "alt"
            },
            {
                type: "number",
                label: "Quality",
                name: "quality"
            },
            {
                type: "string",
                label: "Blur effect (placeholder)",
                name: "placeholder",
                component: "select",
                options: [
                    {
                        value: "empty",
                        label: "empty"
                    },
                    {
                        value: "blur",
                        label: "blur"
                    }
                ]
            },
            {
                type: "string",
                label: "Blur base64",
                name: "blurDataURL",
                ui: {
                    component: "textarea"
                }
            },
            {
                type: "string",
                label: "Object Fit",
                name: "objectFit",
                component: "select",
                default: "none",
                options: [
                    {
                        value: "contain",
                        label: "contain"
                    },
                    {
                        value: "cover",
                        label: "cover"
                    },
                    {
                        value: "fill",
                        label: "fill"
                    },
                    {
                        value: "none",
                        label: "none"
                    }
                ]
            },
            {
                label: "Border Radius",
                name: "borderRadius",
                type: "number",
                description: "value in px"
            },
            {
                label: "Max height for mobile",
                name: "maxHeightMobile",
                type: "boolean",
                description: "Values are in vh"
            },
            {
                type: "boolean",
                label: "Horizontal padding",
                name: "horizontalPadding",
                description: "Only mobile if not in responsiveAsset. Default is false, if true it adds the same padding as on the text"
            }
        ]
    };
};
/* harmony default export */ var tina_responsiveAssetConfig = ((/* unused pure expression or super */ null && (responsiveAssetConfig_responsiveAssetConfig)));

;// CONCATENATED MODULE: ./lib/tina/responsiveAsset.ts

// this is the
const breakpointKeys = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const responsiveAsset = (param)=>{
    let { label , name  } = param;
    const breakpointAssets = breakpointKeys.reduce((memo, key)=>{
        return [
            ...memo,
            responsiveAssetConfig({
                label: key,
                name: key
            })
        ];
    }, []);
    return {
        label,
        name,
        description: "Image URLs and metadata per breakpoint",
        type: "object",
        fields: breakpointAssets
    };
};
/* harmony default export */ var tina_responsiveAsset = ((/* unused pure expression or super */ null && (responsiveAsset)));

;// CONCATENATED MODULE: ./components/TinaResponsiveAsset/TinaResponsiveAsset.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-height: 100vh;\n    flex: 0;\n    margin: 0 auto;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: none;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  display: flex;\n  flex: 1;\n  ",
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        ";\n  padding: 0;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}










const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35b26d8c-0"
})(_templateObject3(), (param)=>{
    let { $horizontalPadding  } = param;
    return $horizontalPadding ? "0 1.5rem" : "0";
}, (param)=>{
    let { theme , $maxHeightMobile  } = param;
    return $maxHeightMobile && theme.mq.ltLg(_templateObject());
}, (param)=>{
    let { max , theme  } = param;
    return max && theme.mq[max](_templateObject1());
}, (param)=>{
    let { min , theme  } = param;
    return min && min !== "xs" && theme.mq["lt".concat(capitalize_default()(min))](_templateObject2());
});
const BreakpointImage = (0,styled_components_browser_esm/* default */.ZP)(TinaAsset/* default */.Z).withConfig({
    componentId: "sc-35b26d8c-1"
})(_templateObject4(), (param)=>{
    let { $borderRadius  } = param;
    return $borderRadius && "".concat($borderRadius, "px");
});
function getNextBreakpoint(currentBp, props) {
    const definedKeys = breakpointKeys.filter((k)=>{
        return props === null || props === void 0 ? void 0 : props[k];
    });
    return first_default()(takeRightWhile_default()(compact_default()(definedKeys), (bp)=>bp !== currentBp));
}
const TinaResponsiveAsset = (param)=>{
    let { asset , className  } = param;
    if (isEmpty_default()(asset)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: breakpointKeys.filter((breakpoint)=>{
            return asset === null || asset === void 0 ? void 0 : asset[breakpoint];
        }).map((breakpoint)=>{
            const max = getNextBreakpoint(breakpoint, asset);
            const { borderRadius , maxHeightMobile , horizontalPadding , ...bpAsset } = (asset === null || asset === void 0 ? void 0 : asset[breakpoint]) || {};
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                $horizontalPadding: !!horizontalPadding,
                min: breakpoint,
                max: max,
                $maxHeightMobile: maxHeightMobile || undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakpointImage, {
                    asset: asset === null || asset === void 0 ? void 0 : asset[breakpoint],
                    className: className,
                    $borderRadius: borderRadius,
                    ...bpAsset
                })
            }, breakpoint);
        })
    });
};
/* harmony default export */ var TinaResponsiveAsset_TinaResponsiveAsset = ((0,styled_components_browser_esm/* default */.ZP)(TinaResponsiveAsset).withConfig({
    componentId: "sc-35b26d8c-2"
})(_templateObject5()));

;// CONCATENATED MODULE: ./components/TinaResponsiveAsset/index.ts



/***/ }),

/***/ 48766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ TinaMarkdown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TinaMarkdown = ({
  content,
  components = {}
}) => {
  if (!content) {
    return null;
  }
  const nodes = Array.isArray(content) ? content : content.children;
  if (!nodes) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes.map((child, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MemoNode, {
      components,
      key: index,
      child
    });
  }));
};
const Leaf = (props) => {
  if (props.bold) {
    const { bold, ...rest } = props;
    if (props.components.bold) {
      const Component = props.components.bold;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("strong", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.italic) {
    const { italic, ...rest } = props;
    if (props.components.italic) {
      const Component = props.components.italic;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("em", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.underline) {
    const { underline, ...rest } = props;
    if (props.components.underline) {
      const Component = props.components.underline;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("u", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.strikethrough) {
    const { strikethrough, ...rest } = props;
    if (props.components.strikethrough) {
      const Component = props.components.strikethrough;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("s", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.code) {
    const { code, ...rest } = props;
    if (props.components.code) {
      const Component = props.components.code;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        ...rest
      }));
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
      ...rest
    }));
  }
  if (props.components.text) {
    const Component = props.components.text;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, props.text);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, props.text);
};
const MemoNode = (props) => {
  const MNode = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Node, {
    ...props
  }), [JSON.stringify(props)]);
  return MNode;
};
const Node = ({ components, child }) => {
  const { children, ...props } = child;
  switch (child.type) {
    case "h1":
    case "h2":
    case "h3":
    case "h4":
    case "h5":
    case "h6":
    case "p":
    case "blockquote":
    case "ol":
    case "ul":
    case "li":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(child.type, {
        children: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        })
      });
    case "lic":
      if (components.lic) {
        const Component2 = components.lic;
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: child.children
      }));
    case "img":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: child.url,
        alt: child.caption
      });
    case "a":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
          components,
          content: children
        }));
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: child.url
      }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TinaMarkdown, {
        components,
        content: children
      }));
    case "code_block":
      const value = child.value;
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("code", null, value));
    case "hr":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("hr", null);
    case "break":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null);
    case "text":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
        components,
        ...child
      });
    case "mdxJsxTextElement":
    case "mdxJsxFlowElement":
      const Component = components[child.name];
      if (Component) {
        const props2 = child.props ? child.props : {};
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {
          ...props2
        });
      } else {
        const ComponentMissing = components["component_missing"];
        if (ComponentMissing) {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ComponentMissing, {
            name: child.name
          });
        } else {
          return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, `No component provided for ${child.name}`);
        }
      }
    case "maybe_mdx":
      return null;
    case "html":
    case "html_inline":
      if (components[child.type]) {
        const Component2 = components[child.type];
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component2, {
          ...props
        });
      }
      return child.value;
    case "invalid_markdown":
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("pre", null, child.value);
    default:
      if (typeof child.text === "string") {
        return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Leaf, {
          components,
          ...child
        });
      }
  }
};



/***/ })

}]);